/**
 * Single source of truth for the public pages' search metadata.
 * Read by <SeoHead /> at runtime and by the build plugin in vite.config.ts,
 * which writes dist/<route>/index.html and dist/sitemap.xml from this list.
 * Kept free of imports so vite.config.ts can load it directly.
 * Titles and descriptions stay English whatever the UI language is.
 */
export const SITE_URL = 'https://evtimia.com'

export interface SeoPage {
  path: string
  title: string
  description: string
}

export const SEO_PAGES: SeoPage[] = [
  {
    path: '/',
    title: 'Digital Marketing Agency in Cluj-Napoca | EVTIMIA',
    description:
      'EVTIMIA plans, creates and automates your online presence: social media, ads, websites and AI automation, built around your business goals. Book a call.',
  },
  {
    path: '/services',
    title: 'Digital Marketing Services: Social, Ads, Web & AI | EVTIMIA',
    description:
      'Six services, one team: social media, PPC ads, websites, automation and brand strategy. You get a written plan, timeline and price before work starts.',
  },
  {
    path: '/portfolio',
    title: 'Portfolio: Client Work & Our Own Projects | EVTIMIA',
    description:
      "Work we've done for clients like eXp Romania, plus Ghid.Online, our free library of short videos on online safety, AI and digital skills.",
  },
  {
    path: '/about',
    title: 'About EVTIMIA: Digital Marketing Social Enterprise',
    description:
      'EVTIMIA is a Cluj-Napoca social enterprise in digital marketing: measurable results, transparent reporting and free digital education for the community.',
  },
  {
    path: '/contact',
    title: 'Contact EVTIMIA | Book a Marketing Consultation',
    description:
      'Book a consultation call or send a message to EVTIMIA, a digital marketing agency in Cluj-Napoca. Email hello@evtimia.com or call +40 742 05 50 50.',
  },
  {
    path: '/services/social-media-subscription',
    title: 'Social Media Management Subscription | EVTIMIA',
    description:
      'Strategy, up to 22 posts a month, monthly video filming and management on Facebook, Instagram, TikTok and LinkedIn. Plans from €999 + VAT a month.',
  },
  {
    path: '/services/automation-ai',
    title: 'Marketing Automation & Custom AI Agents | EVTIMIA',
    description:
      'Funnel automation, CRM integrations and custom AI agents trained on your services: built step by step, tested and handed over with training. From €500 + VAT.',
  },
  {
    path: '/services/web-digital-platforms',
    title: 'Websites, Online Stores & Custom CRMs | EVTIMIA',
    description:
      'Landing pages from €1,100, online stores from €2,500, custom dashboards and CRMs, plus monthly maintenance with on-page SEO. All prices + VAT.',
  },
  {
    path: '/services/strategy-brand-identity',
    title: 'Marketing Strategy & Brand Identity | EVTIMIA',
    description:
      'Marketing strategy, day-to-day project management, ready-to-use logos from €350 and print or digital visual materials, tailored to your business.',
  },
  {
    path: '/services/social-media-alacarte',
    title: 'Social Media Posts, Video & Copywriting | EVTIMIA',
    description:
      'Order social media work by the piece: static posts from €15, video editing from €25, filming sessions, copywriting and on-camera coaching. Prices + VAT.',
  },
  {
    path: '/services/ppc-advertising',
    title: 'PPC Ads: Meta, Google, TikTok & LinkedIn | EVTIMIA',
    description:
      'Paid ads managed on Meta, Google, TikTok, LinkedIn and more: strategy, creatives, daily optimisation and monthly reports. From €350 + VAT a month.',
  },
]

export function canonicalFor(path: string): string {
  return path === '/' ? `${SITE_URL}/` : `${SITE_URL}${path.replace(/\/+$/, '')}`
}

export function seoForPath(pathname: string): SeoPage | undefined {
  const clean = pathname === '/' ? '/' : pathname.replace(/\/+$/, '')
  return SEO_PAGES.find(p => p.path === clean)
}
